var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"has-background":true,"contained":true}},[_c('div',{staticClass:"bg-white p-4 rounded elevation-6"},[_c('div',{staticClass:"header"},[_c('h4',{ref:"leaveFeedbackEasterEgg"},[_vm._v("Leave Feedback")])]),_c('div',{attrs:{"id":"typeForm"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }